// @ts-nocheck

/**
 * YPM_TASKLIST_SRV
 * Tasklist  ## Entity Data Model ![ER Diagram](https://yuml.me/diagram/class/[Header{bg:orange}],[Characteristics{bg:orange}],[Operations{bg:orange}],[HeaderSet{bg:dodgerblue}]++-*>[Header],[CharacteristicsSet{bg:dodgerblue}]++-*>[Characteristics],[OperationsSet{bg:dodgerblue}]++-*>[Operations])  ### Legend ![Legend](https://yuml.me/diagram/plain;dir:TB;scale:60/class/[External.Type{bg:whitesmoke}],[ComplexType],[EntityType{bg:orange}],[EntitySet/Singleton/Operation{bg:dodgerblue}])
 *
 * The version of the OpenAPI document: 0001
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { Header } from '../model/models';
import { ModelError } from '../model/models';
import { Wrapper } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class HeaderSetService {

    protected basePath = 'https://dkasub.corp.lego.com:1443/sap/opu/odata/sap/YPM_TASKLIST_SRV';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get entities from HeaderSet
     * @param $filter Filter items by property values, see [Filtering](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;64)
     * @param $top Show only the first n items, see [Paging - Top](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;66)
     * @param $skip Skip the first n items, see [Paging - Skip](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;65)
     * @param $inlinecount Include count of items, see [Inlinecount](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;67)
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public headerSetGet($filter: string, $top?: number, $skip?: number, $inlinecount?: 'allpages' | 'none', $select?: Array<'taskListType' | 'validFrom' | 'changeNumber' | 'taskListGroup' | 'groupCounter' | 'inactive' | 'counter' | 'createdOn' | 'createdBy' | 'usage' | 'changedOn' | 'description' | 'changedBy' | 'usageDescription' | 'plant' | 'status'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Wrapper>;
    public headerSetGet($filter: string, $top?: number, $skip?: number, $inlinecount?: 'allpages' | 'none', $select?: Array<'taskListType' | 'validFrom' | 'changeNumber' | 'taskListGroup' | 'groupCounter' | 'inactive' | 'counter' | 'createdOn' | 'createdBy' | 'usage' | 'changedOn' | 'description' | 'changedBy' | 'usageDescription' | 'plant' | 'status'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Wrapper>>;
    public headerSetGet($filter: string, $top?: number, $skip?: number, $inlinecount?: 'allpages' | 'none', $select?: Array<'taskListType' | 'validFrom' | 'changeNumber' | 'taskListGroup' | 'groupCounter' | 'inactive' | 'counter' | 'createdOn' | 'createdBy' | 'usage' | 'changedOn' | 'description' | 'changedBy' | 'usageDescription' | 'plant' | 'status'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Wrapper>>;
    public headerSetGet($filter: string, $top?: number, $skip?: number, $inlinecount?: 'allpages' | 'none', $select?: Array<'taskListType' | 'validFrom' | 'changeNumber' | 'taskListGroup' | 'groupCounter' | 'inactive' | 'counter' | 'createdOn' | 'createdBy' | 'usage' | 'changedOn' | 'description' | 'changedBy' | 'usageDescription' | 'plant' | 'status'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if ($filter === null || $filter === undefined) {
            throw new Error('Required parameter $filter was null or undefined when calling headerSetGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($top !== undefined && $top !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$top, '$top');
        }
        if ($skip !== undefined && $skip !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$skip, '$skip');
        }
        if ($filter !== undefined && $filter !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$filter, '$filter');
        }
        if ($inlinecount !== undefined && $inlinecount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>$inlinecount, '$inlinecount');
        }
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Wrapper>(`${this.configuration.basePath}/HeaderSet`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get entity from HeaderSet by key
     * @param taskListType Key which classifies task lists according to their functionality.   Routings are defined under the following task list types:   Routings   Reference operation sets   Rate routings   Reference rate routings   Standard networks   Rough-cut planning profiles
     * @param taskListGroup Key for Task List Group   Key identifying a group.   You can use groups, for instance, to identify two routings that have different production steps for one material.   Enter the group to which you want to restrict the selection.
     * @param groupCounter This key and the task list group uniquely identify a task list.   In Production Planning and Control, for example, it serves to identify alternative production processes in task lists and is used to make a distinction between similar task lists.   The group counter can be used to identify different lot-size ranges, for example.
     * @param counter Internal counter   Identifies the activity posting.
     * @param $select Select properties to be returned, see [Select](https://help.sap.com/doc/5890d27be418427993fafa6722cdc03b/Cloud/en-US/OdataV2.pdf#page&#x3D;68)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public headerSetTaskListTypetaskListTypetaskListGrouptaskListGroupgroupCountergroupCountercountercounterGet(taskListType: string, taskListGroup: string, groupCounter: string, counter: string, $select?: Array<'taskListType' | 'validFrom' | 'changeNumber' | 'taskListGroup' | 'groupCounter' | 'inactive' | 'counter' | 'createdOn' | 'createdBy' | 'usage' | 'changedOn' | 'description' | 'changedBy' | 'usageDescription' | 'plant' | 'status'>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Header>;
    public headerSetTaskListTypetaskListTypetaskListGrouptaskListGroupgroupCountergroupCountercountercounterGet(taskListType: string, taskListGroup: string, groupCounter: string, counter: string, $select?: Array<'taskListType' | 'validFrom' | 'changeNumber' | 'taskListGroup' | 'groupCounter' | 'inactive' | 'counter' | 'createdOn' | 'createdBy' | 'usage' | 'changedOn' | 'description' | 'changedBy' | 'usageDescription' | 'plant' | 'status'>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Header>>;
    public headerSetTaskListTypetaskListTypetaskListGrouptaskListGroupgroupCountergroupCountercountercounterGet(taskListType: string, taskListGroup: string, groupCounter: string, counter: string, $select?: Array<'taskListType' | 'validFrom' | 'changeNumber' | 'taskListGroup' | 'groupCounter' | 'inactive' | 'counter' | 'createdOn' | 'createdBy' | 'usage' | 'changedOn' | 'description' | 'changedBy' | 'usageDescription' | 'plant' | 'status'>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Header>>;
    public headerSetTaskListTypetaskListTypetaskListGrouptaskListGroupgroupCountergroupCountercountercounterGet(taskListType: string, taskListGroup: string, groupCounter: string, counter: string, $select?: Array<'taskListType' | 'validFrom' | 'changeNumber' | 'taskListGroup' | 'groupCounter' | 'inactive' | 'counter' | 'createdOn' | 'createdBy' | 'usage' | 'changedOn' | 'description' | 'changedBy' | 'usageDescription' | 'plant' | 'status'>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (taskListType === null || taskListType === undefined) {
            throw new Error('Required parameter taskListType was null or undefined when calling headerSetTaskListTypetaskListTypetaskListGrouptaskListGroupgroupCountergroupCountercountercounterGet.');
        }
        if (taskListGroup === null || taskListGroup === undefined) {
            throw new Error('Required parameter taskListGroup was null or undefined when calling headerSetTaskListTypetaskListTypetaskListGrouptaskListGroupgroupCountergroupCountercountercounterGet.');
        }
        if (groupCounter === null || groupCounter === undefined) {
            throw new Error('Required parameter groupCounter was null or undefined when calling headerSetTaskListTypetaskListTypetaskListGrouptaskListGroupgroupCountergroupCountercountercounterGet.');
        }
        if (counter === null || counter === undefined) {
            throw new Error('Required parameter counter was null or undefined when calling headerSetTaskListTypetaskListTypetaskListGrouptaskListGroupgroupCountergroupCountercountercounterGet.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($select) {
            queryParameters = this.addToHttpParams(queryParameters,
                $select.join(COLLECTION_FORMATS['csv']), '$select');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Header>(`${this.configuration.basePath}/HeaderSet(taskListType='${encodeURIComponent(String(taskListType))}',taskListGroup='${encodeURIComponent(String(taskListGroup))}',groupCounter='${encodeURIComponent(String(groupCounter))}',counter='${encodeURIComponent(String(counter))}')`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
